export class MediaHashTagModel {
    public mediaHashTagId: string;
    public organisationId: string;
    public mediaHashTagName: string;
    public statusCode: string;
}